import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Database, ChevronRight, DownloadCloud } from "lucide-react";
import api, { errMsg } from "../lib/api";
import PageHeader from "../components/PageHeader";
import { useAuth } from "../context/AuthContext";
import { MASTER_GROUPS, MASTER_DEFS } from "../config/masterDefs";

export default function MasterHub() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const canAdd = user.role === "admin" || (user.permissions || []).includes("add_master");
  const [counts, setCounts] = useState({});
  const [importing, setImporting] = useState(false);

  const loadCounts = () => api.get("/masters").then(({ data }) => {
    setCounts(Object.fromEntries((data || []).map((d) => [d.type, d.count])));
  }).catch(() => {});
  useEffect(() => { loadCounts(); }, []);

  const importFromRecords = async () => {
    if (!window.confirm("Scan existing OA records and back-fill Vehicle, Transporter and Godown masters? Existing entries are never duplicated.")) return;
    setImporting(true);
    try {
      const { data } = await api.post("/masters/import-from-records");
      toast.success(`Imported — ${data.vehicle} vehicle(s), ${data.transporter} transporter(s), ${data.godown} godown(s)`);
      loadCounts();
    } catch (e) { toast.error(errMsg(e)); }
    setImporting(false);
  };

  return (
    <div>
      <PageHeader title="Master Data" subtitle="Reusable records — search, select and add across all OA modules"
        actions={canAdd && <button className="btn-outline" onClick={importFromRecords} disabled={importing} data-testid="master-import-records"><DownloadCloud className="h-4 w-4" /> {importing ? "Importing…" : "Import from OA Records"}</button>} />
      <div className="p-6 lg:p-8 space-y-8">
        {MASTER_GROUPS.map((g) => (
          <div key={g.title}>
            <h3 className="font-head font-semibold text-slate-900 mb-3 flex items-center gap-2"><Database className="h-4 w-4 text-amber-600" /> {g.title}</h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {g.types.map((t) => (
                <button key={t} onClick={() => navigate(`/masters/${t}`)} data-testid={`master-card-${t}`}
                  className="card p-4 text-left hover:border-amber-400 hover:shadow-md transition-all flex items-center justify-between group">
                  <div>
                    <div className="font-semibold text-slate-800">{MASTER_DEFS[t].label}</div>
                    <div className="text-xs text-slate-400">{counts[t] ?? 0} record(s)</div>
                  </div>
                  <ChevronRight className="h-5 w-5 text-slate-300 group-hover:text-amber-500" />
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
